import { useTranslation } from 'react-i18next';

export const MATERIAL_TYPE = {
  MEDIALINK: 'medialink',
  USER_MATERIAL: 'user-material', // teacher only
  SLIDE_SET: 'slide-set', // teacher only
  SHARED_MATERIAL: 'shared-material', // student only
  UNSUPPORTED: 'unsupported',
} as const;

type MaterialType = typeof MATERIAL_TYPE[keyof typeof MATERIAL_TYPE];

export default function useGetMaterialType(materialCategory?: string): MaterialType {
  const { t } = useTranslation();

  if (!materialCategory) return MATERIAL_TYPE.UNSUPPORTED;

  switch (materialCategory) {
    case t('PAGES.CATEGORICAL.VIRTUAL_CATEGORIES.STUDENT.SHARED_MATERIAL.CATEGORY'):
      return MATERIAL_TYPE.SHARED_MATERIAL;
    case t('PAGES.CATEGORICAL.VIRTUAL_CATEGORIES.TEACHER.USER_MATERIAL.CATEGORY'):
      return MATERIAL_TYPE.USER_MATERIAL;
    case t('PAGES.CATEGORICAL.VIRTUAL_CATEGORIES.TEACHER.SLIDE_SETS.CATEGORY'):
      return MATERIAL_TYPE.SLIDE_SET;
    default:
      return MATERIAL_TYPE.MEDIALINK;
  }
}
